export const GET_Q = "GET_Q";
export const GET_Q_SUCCESS = "GET_Q_SUCCESS";
export const GET_Q_FAIL = "GET_Q_FAIL";

export const ADD_Q_SUCCESS = "ADD_Q_SUCCESS";
export const ADD_Q_FAIL = "ADD_Q_FAIL";
export const UPDATE_Q_SUCCESS = "UPDATE_Q_SUCCESS";
export const DELETE_Q_SUCCESS = "DELETE_Q_SUCCESS";
